// Full-body talking set for the deity focus screen: pre-keyed alpha clips (key_hall_clips.py, PREFIX=focus),
// per-frame mouth-patch track (track_face.py), and MuseTalk mouth patches from the shared base frame.
// Every clip starts and ends on that base frame, so any clip can follow any other.
/* eslint-disable @typescript-eslint/no-require-imports */
export type FocusRole = 'idle' | 'gesture' | 'listen';
export interface FocusTrack {
  size: [number, number];
  fps: number;
  roles: FocusRole[];
  clips: Array<Array<[number, number, number, number, number]>>; // per frame: x, y, w, h, match score
}
export interface FocusSet {
  aspect: number;
  poster: number;
  webm: number[];
  mov: number[];
  track: FocusTrack;
  mouths: Record<string, number>;
}
// Off (Joel, 2026-10-11): full-body talking rejected (head motion + lip mismatch); the focus screen uses
// the original waist-up portrait puppet. Clio's full-body set stays on disk (assets/v10/deities/live/clio/
// focus_0.*, focus_track.json, mouth_*.png) with FullBodyPuppet; restore an entry here to re-enable.
export const FOCUS_CLIPS: Record<string, FocusSet> = {};
